import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { BRAND } from "../mock";
import { ALL_SERVICES, CHILD_SEATS } from "../data/pricing";
import { POPULAR } from "../data/cities";
import { useLang } from "../i18n/LanguageContext";

const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#0B1533] text-white/70">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <div className="inline-flex bg-white rounded-xl px-4 py-2.5 mb-5">
              <img src={BRAND.logo} alt={BRAND.name} className="h-11 w-auto object-contain" />
            </div>
            <p className="font-body text-sm leading-relaxed max-w-sm">{t("footer.about")}</p>
            <div className="flex flex-col gap-2 mt-6 font-body text-sm" data-testid="footer-phones">
              {BRAND.phones.map((p, i) => (
                <a key={i} href={p.href} data-testid={`footer-phone-${i}`} className="inline-flex items-center gap-2 hover:text-white transition-colors"><Phone size={15} className="text-[#2B4BFF]" /> {p.number}{p.label ? <span className="opacity-60">({p.label})</span> : null}</a>
              ))}
              <a href={BRAND.emailHref} className="inline-flex items-center gap-2 hover:text-white transition-colors"><Mail size={15} className="text-[#2B4BFF]" /> {BRAND.email}</a>
              <a href={BRAND.addressMap} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 hover:text-white transition-colors"><MapPin size={15} className="text-[#2B4BFF]" /> {BRAND.address}</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4">{t("footer.services")}</h4>
            <ul className="space-y-2.5 font-body text-sm">
              {ALL_SERVICES.slice(0, 6).map((s) => (
                <li key={s.title}><Link to="/#services-detail" className="hover:text-white transition-colors">{s.title}</Link></li>
              ))}
              {CHILD_SEATS.map((c) => (
                <li key={c.id}><Link to={`/kindersitze/${c.slug}`} className="hover:text-white transition-colors">{c.name}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4">{t("footer.routes")}</h4>
            <ul className="space-y-2.5 font-body text-sm">
              {POPULAR.slice(0, 10).map((c) => (
                <li key={c.slug}><Link to={c.path} className="hover:text-white transition-colors">Zürich → {c.name}</Link></li>
              ))}
              <li><Link to="/ziele-alle" data-testid="footer-all-destinations" className="text-[#2B4BFF] font-semibold hover:text-white transition-colors">{t("common.allDestinations")} →</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4">{t("footer.company")}</h4>
            <ul className="space-y-2.5 font-body text-sm">
              <li><Link to="/booking" className="hover:text-white transition-colors">{t("nav.prices")}</Link></li>
              <li><Link to="/ratgeber" className="hover:text-white transition-colors">{t("nav.blog")}</Link></li>
              <li><Link to="/#faq" className="hover:text-white transition-colors">{t("nav.faq")}</Link></li>
              <li><Link to="/#contact" className="hover:text-white transition-colors">{t("nav.contact")}</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-body text-xs">© {year} {BRAND.name}. {t("footer.rights")}</p>
          <p className="font-body text-xs">Flughafenstrasse 1, 8302 Kloten · Schweiz</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
